module.exports = __webpack_public_path__ + "img/baner_font.c9f5629b.png";